import { DeleteIcon } from "src/components";
import { compose } from "src/helpers";
import { withDeleteWorksheet } from "src/modules/worksheet/operations";
import { message } from "antd";
import React from "react";
import { captureException } from "@sentry/react";

const DeleteView = (props: any) => {
    const { deleteWorksheet, id, callback } = props;

    const handleDelete = async () => {
        try {
            await deleteWorksheet(id);
            if (callback) callback();
            message.success("Deleted!");
        } catch (err) {
            captureException(e)
            message.error("Failed!");
        }
    };

    return <DeleteIcon {...props} onConfirm={handleDelete} />;
};

export default compose(withDeleteWorksheet)(DeleteView);
